// src/pages/CapabilitiesTestPage.js

import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
// Using v2 implementation with cleaner sticky structure
import CapabilitiesSection from '../components/capabilities-v2/CapabilitiesSection';
import SEO from '../components/SEO';
import './CapabilitiesTestPage.css';

// Blank spacer section component
const SpacerSection = ({ id }) => (
  <section
    className="spacer-section"
    id={id}
  >
    <div className="spacer-section__label">
      {id === 'spacer-top' ? 'Scroll Down' : 'End of Section'}
    </div>
  </section>
);

function CapabilitiesTestPage() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  return (
    <>
      {/* SEO - noindex test page */}
      <SEO
        title="Capabilities Test"
        noindex={true}
      />

      {/* Progress Bar */}
      <motion.div
        className="progress-bar"
        style={{ scaleX }}
      />

      {/* Back to Home Link */}
      <Link to="/" className="back-link">
        <ArrowLeft size={18} />
        <span>Back to Home</span>
      </Link>

      {/* Section 1: Blank Spacer (100vh) */}
      <SpacerSection id="spacer-top" />

      {/* Section 2: Our Capabilities (500vh) - v2 implementation */}
      <CapabilitiesSection />

      {/* Section 3: Blank Spacer (100vh) */}
      <SpacerSection id="spacer-bottom" />
    </>
  );
}

export default CapabilitiesTestPage;
